

import { Box, ListItemText, SxProps, Theme, Typography } from '@mui/material';
import {StatusButton, StatusChip, SummaryIconWrapper} from './styles'
import FacilityIcon from '../../assets/facility/facility-icon.svg'

interface FacilityProfileTabProps {
  facilityName: string;
  id: number;
  status: string | undefined;
  onClickButton?: (status: string | undefined) => void;
  sx?: SxProps<Theme>;
}

const FacilityProfileTab: React.FC<FacilityProfileTabProps> = ({
  facilityName, 
  id, 
  status, 
  onClickButton,
  sx
}) => {

  
  const getSatusColor = (status: string | undefined): 'success' | 'warning' | 'error' | 'default' => {
    if (status === 'active' || status === 'approved') {
      return 'success';
    } else if (status === 'pending') {
      return 'warning';
    } else if (status === 'blocked') {
      return 'error';
    } else {
      return 'default';
    }
  }

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', ...(sx || {}) }}>
      <SummaryIconWrapper>
        <img src={FacilityIcon} alt='facility-icon' />
      </SummaryIconWrapper>
      <ListItemText
        primary={
          <Typography variant="subtitle1" fontWeight="bold">
            {facilityName}
          </Typography>
        }
        secondaryTypographyProps={{ component: 'div' }}
        secondary={
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <Typography 
              component="span" 
              variant="body2" 
              color="text.secondary"
              sx={{ 
                  marginRight: 2, 
                  lineHeight: '1.2', 
              }}
            >
                {`ID: ${id}`}
            </Typography>
            {status && 
              <StatusChip
                status={(status) ? status : "Pending"}
                label={status}
                size="small"
                color={getSatusColor(status)}
              />
            }
            
          </Box>
        }
        sx={{ marginLeft: 2 }}
      />
      {
        status !== 'pending' && 
        <Box sx={{ flexGrow: 1 }} flexShrink={0} textAlign="right">
          <StatusButton 
            variant="outlined" 
            size="small" 
            color='error'
            status={status ? status : 'Pending'}
            onClick={() => {
              let newStatus  = (status === "approved") ? "suspended" : "approved"; 
              onClickButton && onClickButton(newStatus);
            }}
          >
            {(status === "approved") ? "suspended" : "Reactivate"}
          </StatusButton>
        </Box>
      }
    </Box>
  );
}

export default FacilityProfileTab;